import React from "react";
import clsx from "clsx";
import styles from "./Incentive.module.scss";
import Icon from "../atoms/Icon";

type Variant =
    | "best-seller"
    | "efficient"
    | "sold-out"
    | "available-for-online-sales"
    | "available-for-online-leasing"
    | "limited-stock";

type IncentiveIconProps = {
    variant?: Variant;
};

const IncentiveIcon: React.FC<IncentiveIconProps> = ({ variant }) => {
    switch (variant) {
        case "efficient":
            return <Icon variant="fuelEfficiency" className={styles.icon} sizing="sm" />;
        case "best-seller":
            return <Icon variant="star" className={styles.icon} sizing="sm" />;
        case "sold-out":
            return <Icon variant="close" className={styles.icon} sizing="sm" />;
        case "available-for-online-sales":
            return <Icon variant="check" className={styles.icon} sizing="sm" />;
        case "available-for-online-leasing":
            return <Icon variant="calculator" className={styles.icon} sizing="sm" />;
        case "limited-stock":
            return <Icon variant="incentive-warning" className={styles.icon} sizing="sm" />;
        default:
            return null;
    }
};

export type Props = {
    className?: string;
    variant?: Variant;
    label: string;
} & React.HTMLProps<HTMLDivElement>;

const Incentive: React.FC<Props> = ({ variant = "best-seller", label, className, ...rest }) => {
    return (
        <div className={clsx(styles[variant], className)} {...rest}>
            <IncentiveIcon variant={variant} />
            {label}
        </div>
    );
};

export default Incentive;
